// extracted by mini-css-extract-plugin
export default {"tech":"HW14_tech__xdv1G","loading":"HW14_loading__apbp5","debounce":"HW14_debounce__5Ld0P"};